module.exports = __webpack_public_path__ + "static/banner-video-poster-4-0e1083d421578812c22b523917eb0625.jpg";